import { CardAccountPhoneOutlineIcon } from './CardAccountPhoneOutlineIcon';

/**
 * author: Google
 * id ABC0498A-9F66-489B-A78E-91B3415EE3E4
 * name card-account-phone-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/card-account-phone-outline.svg
 * tags
 * - Account / User 
 */
export const ContactPhoneOutlineIcon = CardAccountPhoneOutlineIcon;
export default ContactPhoneOutlineIcon